import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import relativeTime from 'dayjs/plugin/relativeTime';
import {
  formatCPF,
  formatCNPJ,
  formatPhone,
  formatCellPhone,
  formatZipCode,
  normalizeBRDate,
  roundNumber,
} from '../lib/helpers';
import { useMediaQuery } from '@vueuse/core';

dayjs.extend(relativeTime);
dayjs.locale('pt-br');

const isLargeScreen = useMediaQuery('(min-width: 960px)')

export default {
  install(app) {
    app.config.globalProperties.$toCurrency = (value, onlyNumber = false, currency = 'BRL') => {
      value = Number(value) || 0;
      return onlyNumber
        ? value.toLocaleString('pt-BR')
        : value.toLocaleString('pt-BR', { style: 'currency', currency })
    };

    app.config.globalProperties.$toDecimal = (value) => {
      value = Number(value) || 0;
      return value.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2 })
    };

    app.config.globalProperties.$toNumber = (value) => {
      return Number(value.replace(/\./g, '').replace(/,/g, '.')) || 0;
    };

    app.config.globalProperties.$getCurrencyMask = () => {
      return { mask: '############', tokens: { '#': { pattern: /\d|,|\./ } } };
    };

    app.config.globalProperties.$toDimension = (value, dimension = 'm²') => {
      return `${Number(value).toLocaleString('pt-BR')} ${dimension}`;
    };

    app.config.globalProperties.$formatDate = (date) => {
      return date
        ? dayjs(date).format('DD/MM/YYYY')
        : null;
    };

    app.config.globalProperties.$formatCPF = formatCPF;
    app.config.globalProperties.$formatCNPJ = formatCNPJ;
    app.config.globalProperties.$formatPhone = formatPhone;
    app.config.globalProperties.$formatCellPhone = formatCellPhone;
    app.config.globalProperties.$formatZipCode = formatZipCode;
    app.config.globalProperties.$normalizeBRDate = normalizeBRDate;
    app.config.globalProperties.$roundNumber = roundNumber;
    app.config.globalProperties.$dayjs = dayjs;
    app.config.globalProperties.$isLargeScreen = isLargeScreen;
    app.config.globalProperties.$downloadFile = (filename, data) => {
      const blob = new Blob([data]);
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    };
    app.config.globalProperties.$sliceText = (text, size) => {
      if (!text || text.length <= size) {
        return text;
      }
      return `${text.slice(0, size)}...`;
    };
    app.config.globalProperties.$formatDocument = (value) => {
      value = value || '';
      if (value.length === 11) {
        return formatCPF(value);
      }
      if (value.length > 11) {
        return formatCNPJ(value);
      }
      return value;
    };
  },
};
